import { Box, Center, Container, Heading } from "@chakra-ui/react";
import { useGetPrivacyPolicyQuery } from "../../features/cmsApi";
import RichTextRenderer from "../../common/RichTextRenderer";

function PrivacyPolicy() {
  const { data } = useGetPrivacyPolicyQuery();


  return (
    <Container my={10} maxW="container.lg">
      <Center>
        <Heading size="2xl" fontWeight={"semibold"} color="blue.700" mb={8}>
          {data?.data?.title || "Privacy Policy"}
        </Heading>
      </Center>
      <Box my={10}>
        {data?.data && <RichTextRenderer content={data?.data?.content} />}
      </Box>
    </Container>
  );
}

export default PrivacyPolicy;
